import { differenceInDays } from 'date-fns/differenceInDays'

import { EPOCH } from '@/defs/date'

import { parseUnknownDate } from './parseUnknownDate'

export const getDaysSinceEpoch = (date: string) => differenceInDays(parseUnknownDate(date) || 0, EPOCH)
